export const second = 1000;
export const seconds = (count: number) => count * second;

export const minute = 60 * second;
export const minutes = (count: number) => count * minute;

export const hour = 60 * minute;
export const hours = (count: number) => count * hour;

export const day = 24 * hour;
export const days = (count: number) => count * day;

export const week = 7 * day;
export const weeks = (count: number) => count * week;
